import {
  calculateServiceFees as publicCalculateServiceFees,
  createRule as publicCreateRule,
  getRule as publicGetRule,
  updateRule as publicUpdateRule,
  deleteRule as publicDeleteRule,
  listRules as publicListRules,
  queryRules as publicQueryRules,
  typedQueryRules as publicTypedQueryRules,
  bulkCreateRules as publicBulkCreateRules,
  bulkUpdateRules as publicBulkUpdateRules,
  bulkDeleteRules as publicBulkDeleteRules,
  bulkUpdateRuleTags as publicBulkUpdateRuleTags,
  bulkUpdateRuleTagsByFilter as publicBulkUpdateRuleTagsByFilter,
} from './service-fees-v1-rule-service-fees.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  RuleQuery,
  RulesQueryBuilder,
  typedQueryRules as universalTypedQueryRules,
} from './service-fees-v1-rule-service-fees.universal.js';
import { onRuleCreated as publicOnRuleCreated } from './service-fees-v1-rule-service-fees.public.js';
import { onRuleDeleted as publicOnRuleDeleted } from './service-fees-v1-rule-service-fees.public.js';
import { onRuleUpdated as publicOnRuleUpdated } from './service-fees-v1-rule-service-fees.public.js';

function customQueryRules(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryRules(httpClient)(),
    typedQueryFunction: (query: RuleQuery) =>
      publicTypedQueryRules(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): RulesQueryBuilder;
  function overloadedQuery(
    query: RuleQuery
  ): ReturnType<typeof universalTypedQueryRules>;
  function overloadedQuery(query?: RuleQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const calculateServiceFees: MaybeContext<
  BuildRESTFunction<typeof publicCalculateServiceFees> &
    typeof publicCalculateServiceFees
> = /*#__PURE__*/ createRESTModule(publicCalculateServiceFees);
export const createRule: MaybeContext<
  BuildRESTFunction<typeof publicCreateRule> & typeof publicCreateRule
> = /*#__PURE__*/ createRESTModule(publicCreateRule);
export const getRule: MaybeContext<
  BuildRESTFunction<typeof publicGetRule> & typeof publicGetRule
> = /*#__PURE__*/ createRESTModule(publicGetRule);
export const updateRule: MaybeContext<
  BuildRESTFunction<typeof publicUpdateRule> & typeof publicUpdateRule
> = /*#__PURE__*/ createRESTModule(publicUpdateRule);
export const deleteRule: MaybeContext<
  BuildRESTFunction<typeof publicDeleteRule> & typeof publicDeleteRule
> = /*#__PURE__*/ createRESTModule(publicDeleteRule);
export const listRules: MaybeContext<
  BuildRESTFunction<typeof publicListRules> & typeof publicListRules
> = /*#__PURE__*/ createRESTModule(publicListRules);
export const bulkCreateRules: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateRules> & typeof publicBulkCreateRules
> = /*#__PURE__*/ createRESTModule(publicBulkCreateRules);
export const bulkUpdateRules: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateRules> & typeof publicBulkUpdateRules
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateRules);
export const bulkDeleteRules: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteRules> & typeof publicBulkDeleteRules
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteRules);
export const bulkUpdateRuleTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateRuleTags> &
    typeof publicBulkUpdateRuleTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateRuleTags);
export const bulkUpdateRuleTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateRuleTagsByFilter> &
    typeof publicBulkUpdateRuleTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateRuleTagsByFilter);
export const queryRules: MaybeContext<
  BuildRESTFunction<typeof customQueryRules> & typeof customQueryRules
> = /*#__PURE__*/ createRESTModule(customQueryRules);
/** */
export const onRuleCreated: BuildEventDefinition<typeof publicOnRuleCreated> &
  typeof publicOnRuleCreated = createEventModule(publicOnRuleCreated);
/** */
export const onRuleDeleted: BuildEventDefinition<typeof publicOnRuleDeleted> &
  typeof publicOnRuleDeleted = createEventModule(publicOnRuleDeleted);
/** */
export const onRuleUpdated: BuildEventDefinition<typeof publicOnRuleUpdated> &
  typeof publicOnRuleUpdated = createEventModule(publicOnRuleUpdated);

export {
  Value,
  ExpectedFieldType,
  Operation,
  Operator,
  ConditionsType,
  ConditionType,
  RoundingStrategy,
  Type,
  PlatformValue,
  SortOrder,
  WebhookIdentityType,
} from './service-fees-v1-rule-service-fees.universal.js';
export {
  Rule,
  RuleValueOneOf,
  RuleRequirementsOneOf,
  RuleConditionsOneOf,
  RuleConditionTypeOptionsOneOf,
  RuleTaxesOneOf,
  CommonMoney,
  Money,
  Condition,
  ConditionValueOneOf,
  ExpectedType,
  _Number,
  List,
  ConditionTree,
  ConditionTreeLeftConditionNodeOneOf,
  ConditionTreeRightConditionNodeOneOf,
  ExtendedFields,
  Tags,
  TagList,
  CalculateServiceFeesRequest,
  Order,
  PriceSummary,
  ShippingInformation,
  DeliveryLogistics,
  Platform,
  Locale,
  CalculateServiceFeesResponse,
  CalculatedFee,
  CreateRuleRequest,
  CreateRuleResponse,
  GetRuleRequest,
  GetRuleResponse,
  UpdateRuleRequest,
  UpdateRuleResponse,
  DeleteRuleRequest,
  DeleteRuleResponse,
  ListRulesRequest,
  ListRulesResponse,
  QueryRulesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  AddressLocation,
  CursorPaging,
  QueryRulesResponse,
  CursorPagingMetadata,
  Cursors,
  BulkCreateRulesRequest,
  BulkCreateRulesResponse,
  BulkRuleResult,
  CommonItemMetadata,
  ApplicationError,
  CommonBulkActionMetadata,
  BulkUpdateRulesRequest,
  MaskedRule,
  BulkUpdateRulesResponse,
  BulkDeleteRulesRequest,
  BulkDeleteRulesResponse,
  BulkUpdateRuleTagsRequest,
  BulkUpdateRuleTagsResponse,
  ItemMetadata,
  BulkUpdateRuleTagsResult,
  BulkActionMetadata,
  BulkUpdateRuleTagsByFilterRequest,
  BulkUpdateRuleTagsByFilterResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  RuleCreatedEnvelope,
  RuleDeletedEnvelope,
  RuleUpdatedEnvelope,
  CalculateServiceFeesOptions,
  UpdateRule,
  ListRulesOptions,
  RulesQueryResult,
  RulesQueryBuilder,
  RuleQuerySpec,
  BulkCreateRulesOptions,
  BulkUpdateRulesOptions,
  BulkUpdateRuleTagsOptions,
  BulkUpdateRuleTagsByFilterOptions,
} from './service-fees-v1-rule-service-fees.universal.js';
export { utils } from './service-fees-v1-rule-service-fees.universal.js';
export {
  ValueWithLiterals,
  ExpectedFieldTypeWithLiterals,
  OperationWithLiterals,
  OperatorWithLiterals,
  ConditionsTypeWithLiterals,
  ConditionTypeWithLiterals,
  RoundingStrategyWithLiterals,
  TypeWithLiterals,
  PlatformValueWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateRuleTagsApplicationErrors,
  BulkUpdateRuleTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  RuleQuery,
} from './service-fees-v1-rule-service-fees.universal.js';
